import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const networkRulesService = {
  // Rule Sets
  getRuleSets: () => api.get('/network-rule-sets').then((r) => r.data),
  getRuleSet: (id) => api.get(`/network-rule-sets/${id}`).then((r) => r.data),
  createRuleSet: (data) => api.post('/network-rule-sets', data).then((r) => r.data),

  // Rules
  getRules: (params) => api.get('/network-rules', { params }).then((r) => r.data),
  getRule: (id) => api.get(`/network-rules/${id}`).then((r) => r.data),
  createRule: (data) => api.post('/network-rules', data).then((r) => r.data),
  updateRule: (id, data) => api.put(`/network-rules/${id}`, data).then((r) => r.data),
  deleteRule: (id) => api.delete(`/network-rules/${id}`).then((r) => r.data),

  // Import / Export
  importRules: (data) => api.post('/network-rules/import', data).then((r) => r.data),
  exportExtension: (ruleSetId) =>
    api.get(`/network-rule-sets/${ruleSetId}/export/extension`).then((r) => r.data),
  exportSquid: (ruleSetId) =>
    api.get(`/network-rule-sets/${ruleSetId}/export/squid`, { responseType: 'text' }).then((r) => r.data),
  exportPac: (ruleSetId) =>
    api.get(`/network-rule-sets/${ruleSetId}/export/pac`, { responseType: 'text' }).then((r) => r.data),

  // Seed
  seed: () => api.post('/network-rules/seed').then((r) => r.data),

  // Summary
  getRuleSummaryByApp: () => api.get('/network-rules/summary/by-app').then((r) => r.data),

  // Element Hide Rules
  getElementHideRules: (params) => api.get('/element-hide-rules', { params }).then((r) => r.data),
  createElementHideRule: (data) => api.post('/element-hide-rules', data).then((r) => r.data),
  updateElementHideRule: (id, data) => api.put(`/element-hide-rules/${id}`, data).then((r) => r.data),
  deleteElementHideRule: (id) => api.delete(`/element-hide-rules/${id}`).then((r) => r.data),
};

export default networkRulesService;
